import { apiGet, apiPost, apiPut, apiDelete } from './client'

export interface NoteRow {
  id: string
  tenant_id: string
  object_id: string
  record_id: string
  content: string
  created_by: string
  updated_at: string
  created_at: string
}

export async function fetchNotes(objectId: string, recordId: string) {
  return apiGet<{ data: NoteRow[] }>(`/objects/${objectId}/records/${recordId}/notes`)
}

export async function createNote(objectId: string, recordId: string, content: string) {
  return apiPost<{ data: NoteRow }, { content: string }>(
    `/objects/${objectId}/records/${recordId}/notes`,
    { content },
  )
}

export async function updateNote(objectId: string, recordId: string, noteId: string, content: string) {
  return apiPut<{ data: NoteRow }, { content: string }>(
    `/objects/${objectId}/records/${recordId}/notes/${noteId}`,
    { content },
  )
}

export async function deleteNote(objectId: string, recordId: string, noteId: string) {
  return apiDelete<{ data: null }>(`/objects/${objectId}/records/${recordId}/notes/${noteId}`)
}
